import { render, staticRenderFns } from "./ReceiverGroup.vue?vue&type=template&id=0d08981c"
import script from "./ReceiverGroup.vue?vue&type=script&lang=js"
export * from "./ReceiverGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports